import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import OffCanvas from "../Components/FormTag/OffCanvas";
import CommonModal from "../Components/Modals/CommonModal";
import ViewScanLogLayout from "./ViewScanLogLaout";
import { vewscanlogData } from "../Data/testData";

interface HistoryLayoutProps {
  isShowCanvas: boolean;
  handelCanvas: () => void;
  showViewScanLogs?: boolean;
  data?: {
    viewscanlog?: string;
    day: string;
    items: {
      time: string;
      description: string;
      person: string;
      status?: string;
    }[];
  }[];
}

const HistoryLayout: React.FC<HistoryLayoutProps> = ({
  isShowCanvas,
  handelCanvas,
  data,
  showViewScanLogs,
}) => {
  const headerChildren = (
    <div className="d-flex align-items-center gap-1">
      <Dropdown>
        <Dropdown.Toggle
          className="btn bg-white text-dark dropdown-toggle"
          id="dropdown-basic"
        >
          Newest to oldest
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item href="#/action-1" className="dropdown-toggle-item">
            Oldest to newest
          </Dropdown.Item>
          <Dropdown.Item href="#/action-2" className="dropdown-toggle-item">
            Newest to oldest
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );

  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(!show);
  const closeDeleteKitModal = () => {
    setShowModal(false);
  };
  const handelviewscanlogAction = () => {
    setShowModal(true);
  };

  return (
    <>
      <OffCanvas
        show={isShowCanvas}
        handleClose={handelCanvas}
        title="HISTORY"
        headerChildren={headerChildren}
      >
        <div className="offcanvas-body asn-offcanvas-height custom-scrollbar mb-2 d-flex flex-column py-0">
            <>
              {showViewScanLogs && (
                <a
                  href="#"
                  className="text-primary"
                  onClick={() => handelviewscanlogAction()}
                >
                  View Scan Logs
                </a>
              )}
          {data?.map((section) => (
              <div className="today border-left ms-3 mt-4" key={section.day}>
                <div className="body-heading1 mb-3 position-relative timeline-circle1">
                  <h6 className="text-accent ps-4">{section.day}</h6>
                  <i className="bull-dot me-2 position-absolute top-50 start-0 translate-middle"></i>
                </div>
                {section.items.map((item, index) => (
                  <div
                    className="milestone-1 fs-14 mb-4 position-relative timeline-circle1"
                    key={index}
                  >
                    <i className="bull-dot me-2 position-absolute top-50 start-0 translate-middle"></i>
                    <div className="d-flex ps-4">
                      <p className="fc-gray mb-1 fs-12">
                        {item.time} {item.description}
                      </p>
                    </div>
                    <div className="d-flex align-items-center">
                      <p className="fc-gray ps-4 mb-0">{item.person}</p>
                      <span
                        className={`fs-11 mb-0 py-1 px-2 ms-auto w-112 text-center ${
                          item.status === "Completed" ||
                          item.status === "Check-in Complete" ||
                          item.status === "Putaway Complete" ||
                          item.status === "Shipped" ||
                          item.status === "Pack Complete" ||
                          item.status === "Pick Complete"
                            ? "offcanvas-status-border-green"
                            : item.status === "In Progress" ||
                            item.status === "Pack In Progress" ||
                            item.status === "In Picking" 
                            ? "offcanvas-status-border-orange"
                            : item.status === "New" ||
                              item.status === "Ready to Check-in" ||
                              item.status === "Ready To Pick" ||
                              item.status === "Ready To Pack"
                            ? "offcanvas-status-border-blue"
                            : ""
                        } w-112 text-center`}
                      >
                        {item.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ))}
            </>
     
        </div>
        <div className="offcanvs-footer d-flex justify-content-end  px-0 border-top pt-3 mt-auto mb-3">
          <button
            className="btn offcanvas-close-btn px-4 fs-14"
            onClick={handelCanvas}
          >
            Close
          </button>
        </div>
      </OffCanvas>

      <CommonModal
        handleClose={closeDeleteKitModal}
        show={showModal}
        content={<ViewScanLogLayout handleClose={handleShow} scanLogData={vewscanlogData[0]} />}
        modalSize="modal-xl"
        footerButtonsActive={false}
        heading="SCAN LOG"
        rightHeaderComponent={headerChildren}
        customClassName="view-scan-log-modal"
      />
    </>
  );
};

export default HistoryLayout;
